import {
    ContentAdditionalProductFragment,
    EventCtaFragment,
    LinkCtaFragment,
} from '@graphql/generated/graphql';

import { StoryPageCta } from '../types';

export const getEventsAndLinks = (ctas?: StoryPageCta[]) =>
    ctas?.filter(
        (cta) =>
            cta.__typename === 'ComponentCtaEventCallToAction' ||
            cta.__typename === 'ComponentCtaLinkCallToAction'
    ) as (EventCtaFragment | LinkCtaFragment)[];

export const getAdditionalProducts = (
    ctas?: StoryPageCta[]
): ContentAdditionalProductFragment[] | undefined =>
    ctas?.filter(
        (cta) => cta.__typename === 'ComponentContentAdditionalProduct'
    ) as ContentAdditionalProductFragment[];
